export default __webpack_public_path__ + "static/media/map_icon.2e46c6d0.png";